import React from 'react';
import Scroll from 'react-scroll';
import DateTimePicker from 'react-datetime-picker';

class FieldDateTime extends React.Component {
  
  render() {
    const key = this.props.id;
    const field = this.props.field;
    const visible = this.props.visible;
    const editable = this.props.editable;
    const mandatory = this.props.mandatory;
    const value = this.props.value;
    const error = this.props.error;
    const errorMessage = this.props.errorMessage;

    if(!visible || !editable) return null;
    
    return (
      <div className="col">
        <div className="form-group">
          <Scroll.Element name={this.props.id} />
          <label> {field.label_name} { mandatory ? <span className="required-field"/> : null} </label>
          { error ? <>&nbsp; : &nbsp; <label className="error-w">{errorMessage}</label></> : null }
          <DateTimePicker
            className={`custom-select ${error ? 'error-w' : ''}`}
            value={value}
            format="dd-MM-y h:mm a"
            onChange={date => this.props.onValueChange(key, date)}
            disabled={!editable} />
        </div>
      </div>
    );
  }
}
export default FieldDateTime;